// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SvgLoader {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 9px 0 9px 0;
}
.SvgLoader img {
  height: 15px;
}
.SvgLoader.leftAligned {
  justify-content: flex-start;
}
.SvgLoader.asOverlay {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 100;
}
`, "",{"version":3,"sources":["webpack://./src/components/SvgLoader/SvgLoader.less"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AACF;AARA;EAUI,YAAA;AACJ;AAEE;EACE,2BAAA;AAAJ;AAGE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,0CAAA;EACA,YAAA;AADJ","sourcesContent":[".SvgLoader {\n  box-sizing: border-box;\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 9px 0 9px 0;\n\n  img {\n    height: 15px;\n  }\n\n  &.leftAligned {\n    justify-content: flex-start;\n  }\n\n  &.asOverlay {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    bottom: 0px;\n    left: 0px;\n    background-color: rgba(255, 255, 255, 0.8);\n    z-index: 100;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
